import React from "react";
import { NavLink } from "react-router-dom";
import styles from "./Sidebar.module.scss";
import logo from "../images/logo.png";

function Sidebar() {
  const menuItems = [
    { id: "overview", label: "Tableau de Bord", to: "/dashboard/overview" },
    { id: "reservations", label: "Réservations", to: "/dashboard/reservations" },
    { id: "contact", label: "Messages de Contact", to: "/dashboard/contact" },
  ];

  return (
    <div className={styles.sidebar}>
      <div className={styles.logoArea}>
        <img src={logo} alt="Palais Royal" className={styles.logo} />
        <p className={styles.subtitle}>Système de Gestion</p>
      </div>
      <nav className={styles.navMenu}>
        {menuItems.map((item) => (
          <NavLink
            key={item.id}
            to={item.to}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.active : ""}`
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </div>
  );
}

export default Sidebar;
